import React from "react";
import "./Header.css";

const Header = () => {
    // Smooth scroll function for navigation links
    const scrollToSection = (id) => {
        const element = document.getElementById(id);
        if (element) {
            element.scrollIntoView({ behavior: "smooth", block: "start" });
        }
    };

    // Scroll to top for the Check Eligibility button
    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    };

    return (
        <header className="dm-main-header">
            <div className="dm-header-container">

                {/* Left: Logo */}
                <div className="dm-header-logo" onClick={scrollToTop} style={{ cursor: "pointer" }}>
                    {/* Adjust the src to match your actual logo file path */}
                    <img src={`${process.env.PUBLIC_URL}/assets/img/Group%20494.svg`} alt="DigitMoney" className="brand-logo-img" />
                </div>

                {/* Center/Right: Navigation Links (Hidden on Mobile) */}
                <nav className="dm-header-nav">
                    <button onClick={() => scrollToSection("why-us")} className="dm-nav-link">
                        Why us
                    </button>
                    <button onClick={() => scrollToSection("use-cases")} className="dm-nav-link">
                        Use cases
                    </button>
                    <button onClick={() => scrollToSection("process")} className="dm-nav-link">
                        Process
                    </button>
                </nav>

                {/* Right: CTA Button */}
                <div className="dm-header-cta">
                    <button onClick={scrollToTop} className="dm-eligibility-btn">
                        Check Eligibility <span>→</span>
                    </button>
                </div>

            </div>
        </header>
    );
};

export default Header;